import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import { DateTime } from 'scaleflow/utils/date-time';

class BacklogInitiativesInitiativePlanningWorkstreamsUnfiledRoute extends Route {
  @service store;

  today = DateTime.now().add(2, 'days').format('YYYY-MM-DD');
  six_months_ago = DateTime.now().subtract(6, 'months').format('YYYY-MM-DD');

  model() {
    const { initiative } = this.paramsFor('backlog.initiatives.initiative');
    return this.store.query('tfo', {
      filter: {
        archived: true,
        initiative,
        after: this.six_months_ago,
        before: this.today,
      },
    });
  }
}

export default instrumentRoutePerformance(
  BacklogInitiativesInitiativePlanningWorkstreamsUnfiledRoute,
);
